class NotifyMe extends HTMLElement {
	connectedCallback() {
		this.buttonGroup = this.querySelector('.product-form__button-group');
		this.variantId = this.dataset.variantId;

		if (!this.buttonGroup) return;

		this.addEventListener('click', (e) => {
			if (e.target.closest('[data-notify-me]')) {
				this.showForm();
			}
		});
	}

	showForm() {
		var preOrderMessage = document.querySelector('[data-origin="metafields.pre_order_data"]');
		if (preOrderMessage) preOrderMessage.style.display = 'none';

		this.buttonGroup.innerHTML = '';

		var form = document.createElement('form');
		form.className = 'notify-me__form';
		form.setAttribute('novalidate', '');

		var input = document.createElement('input');
		input.id = 'notify-me-email';
		input.type = 'email';
		input.name = 'email';
		input.className = 'notify-me__input';
		input.placeholder = this.dataset.placeholderEmail;
		input.required = true;

		if (this.dataset.customerEmail) {
			input.value = this.dataset.customerEmail;
		}

		var button = document.createElement('button');
		button.type = 'submit';
		button.className = 'notify-me__send';
		button.innerHTML = '<span>' + this.dataset.labelSend + '</span>';

		form.appendChild(input);
		form.appendChild(button);
		this.buttonGroup.appendChild(form);

		if (this.dataset.disclaimerText) {
			var disclaimer = document.createElement('p');
			disclaimer.className = 'notify-me__disclaimer';
			disclaimer.textContent = this.dataset.disclaimerText;
			this.buttonGroup.appendChild(disclaimer);
		}

		input.focus();

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			this.handleSubmit(input.value);
		});
	}

	async handleSubmit(email) {
		if (!this.validateEmail(email)) {
			this.showError(this.dataset.errorEmail);
			return;
		}

		var sendButton = this.buttonGroup.querySelector('.notify-me__send');
		sendButton.disabled = true;

		try {
			var response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + this.dataset.companyId, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'revision': '2024-06-15',
				},
				body: JSON.stringify({
					data: {
						type: 'back-in-stock-subscription',
						attributes: {
							channels: ['EMAIL'],
							profile: {
								data: {
									type: 'profile',
									attributes: {
										email: email,
									},
								},
							},
						},
						relationships: {
							variant: {
								data: {
									type: 'catalog-variant',
									id: '$shopify:::$default:::' + this.variantId,
								},
							},
						},
					},
				}),
			});

			if (response.ok || response.status === 202) {
				this.showSuccess();
			} else {
				throw new Error('Request failed: ' + response.status);
			}
		} catch (error) {
			console.error('Notify Me error:', error);
			this.showError(this.dataset.errorText);
		}
	}

	showSuccess() {
		var form = this.buttonGroup.querySelector('.notify-me__form');
		var input = this.buttonGroup.querySelector('.notify-me__input');
		var sendButton = this.buttonGroup.querySelector('.notify-me__send');

		sendButton.remove();
		input.replaceWith(Object.assign(document.createElement('span'), {
			className: 'notify-me__input',
			textContent: this.dataset.messageSuccess,
		}));
		form.classList.add('notify-me__form--success');
	}

	showError(message) {
		var form = this.buttonGroup.querySelector('.notify-me__form');
		var input = this.buttonGroup.querySelector('.notify-me__input');
		var sendSpan = this.buttonGroup.querySelector('.notify-me__send span');
		var sendButton = this.buttonGroup.querySelector('.notify-me__send');

		form.classList.add('notify-me__form--error');
		input.value = '';
		input.placeholder = message;
		input.classList.add('notify-me__input--error');
		sendSpan.textContent = this.dataset.labelTryAgain;
		sendButton.disabled = false;

		input.addEventListener('input', () => {
			form.classList.remove('notify-me__form--error');
			input.classList.remove('notify-me__input--error');
			input.placeholder = this.dataset.placeholderEmail;
			sendSpan.textContent = this.dataset.labelSend;
		}, { once: true });
	}

	validateEmail(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}
}

customElements.define('notify-me', NotifyMe);
